<div class="tt-c-previous-ratings tt-u-spacing--sm">
  <div class="tt-c-previous-ratings__heading" v-html="$msg('review.previousRatings', [], previousRatings.length)"></div>
  <div v-for="previous in previousRatings" class="tt-c-previous-ratings__wrap">
    <tt-rating-stars :rating="previous.rating" size="sm" class="tt-c-previous-ratings__rating"></tt-rating-stars>
    <span class="tt-c-previous-ratings__date">{{ previous.updateDateFormatted }}</span>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/components/review/previous-ratings.html